import React, {memo} from "react";

import {LineChart} from "../../../atoms/admin-reporting/atoms/line-chart";
import {RequiredUserPermission} from "../../../atoms/admin-user-permissions/RequiredUserPermission";
import {UserPermissionEnum} from "../../../utils/types/user";
import {ReportingContext} from "../ReportingContext";
import {
  AnalyticsType,
  ReportingContextType,
} from "../../../store/reporting/reporting.common";
import {CardTitle} from "../../../atoms/card-title";
import {CompareDateLabel} from "../../../atoms/reporting-compare";
import {
  ChartProps,
  Props,
  useOnDataPathChange,
  lineGraphData,
  withCompare,
} from "./helpers";
import {CompareDateLabelsWrapper} from "../reports/Report.common";

const AnalyticsWithoutMedicalSupplementTimeSeriesChart = memo(
  ({data}: ChartProps) => <LineChart data={lineGraphData(data)} />,
);

export const WITHOUT_MEDICARE_SUPPLEMENT_CHART_ID =
  "without-medicare-supplement" as const;

export const AnalyticsWithoutMedicalSupplementTimeSeries = (props: Props) => (
  <RequiredUserPermission
    permission={UserPermissionEnum.PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT}
  >
    <div className="chart-header">
      <CardTitle title="Resident without Medicare" subtitle="by Admissions" />
      <CompareDateLabelsWrapper>
        <CompareDateLabel dateRange={props.dateRange} global />
      </CompareDateLabelsWrapper>
    </div>
    <ReportingContext
      dataPaths={withCompare({
        what: ReportingContextType.analyticsWithoutResolution,
        type: AnalyticsType.missingMedicareRate,
        query: {...props.dateRange},
        facilities: props.facilities,
      })}
      onDataPathChange={useOnDataPathChange(props.reportingBlockSetters)}
      isFullReport={props.reportingBlockSetters.isFullReport}
      enabled={props.reportingBlockSetters.enabled}
    >
      {(data, isFullReport) => (
        <AnalyticsWithoutMedicalSupplementTimeSeriesChart
          data={data}
          isFullReport={isFullReport}
        />
      )}
    </ReportingContext>
  </RequiredUserPermission>
);
